import React from "react";
// Customizable Area Start
import {
  createTheme,
  ThemeProvider,
  styled,
} from '@mui/material/styles';
import { Box, Checkbox, Chip, Typography } from "@mui/material";
import CheckIcon from '@mui/icons-material/Check';

export const theme = createTheme({
  typography: {
    fontFamily: "Montserrat !important",
    h1: {
      fontSize: "24px",
      fontWeight: "500",
      lineHeight: "29.26px",
      color: "#0F172A",
    },
    h3: {
      fontSize: "28px",
      fontWeight: "600",
      lineHeight: "32px",
      color: "#0F172A",
    },
    h4: {
      fontSize: "38px",
      fontWeight: "500",
      lineHeight: "43.68px",
      color: "#0F172A",
    },
    h6: {
      fontSize: "14px",
      fontWeight: "300",
      lineHeight: "18.72px",
      color: "#0F172A",
    },
    subtitle1: {
      fontSize: "20px",
      fontWeight: "600",
      lineHeight: "24.38px",
      color: "#0F172A",
    },
    body1: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "18px",
      color: "#1E293B",
    },
    body2: {
      fontSize: "16px",
      fontWeight: "500",
      lineHeight: "24px",
      color: "#64748B",
    },
  }
});
import OrderReviewController, {
  Props,
  IFeature
} from "./OrderReviewController.web";
import NavigationMenu from "../../../blocks/navigationmenu/src/NavigationMenu.web";
import AppFooter from "../../../components/src/AppFooter.web";
import CustomButton from "../../../components/src/CustomButton.web";
import { formatCurrency } from "../../../components/src/utils";
import CustomInfoDialog from "../../../components/src/CustomInfoDialog.web";
import FullPageLoader from "../../../components/src/FullPageLoader.web";
const configJSON = require("./config.js")
const PlansConfigJSON = require("../../customisableusersubscriptions/src/config.js")
// Customizable Area End

export default class OrderReview extends OrderReviewController {
  constructor(props: Props) {
    super(props);
    // Customizable Area Start
    // Customizable Area End
  }

  // Customizable Area Start
  // Customizable Area End

  render() {
    // Customizable Area Start
    const {
      isLoading,
      isInfoDialog,
      infoType,
      infoMessage,
      infoDescription,
      orderDetails,
      isAutoRenewal,
    } = this.state
    // Customizable Area End
    return (
      // Customizable Area Start
      <ThemeProvider theme={theme}>
        <FullPageLoader isLoading={isLoading} />
        <NavigationMenu id="" navigation={this.props.navigation} />
        <Wrapper>
          {orderDetails && (
            (() => {
              const {
                attributes: {
                  account,
                  order_number,
                  gst,
                  order_date,
                  subscription,
                  total,
                  valid_date,
                  sub_total,
                },
              } = orderDetails;

              const { name, price } = subscription;
              const features = PlansConfigJSON.PLAN_DETAILS[name].features

              return (
                <>
                  <Box sx={{ marginBottom: "40.5px" }}>
                    <Typography
                      variant="h1"
                      align="center"
                      data-test-id="pageTitle"
                      gutterBottom
                    >
                      {configJSON.reviewYourOrderText}
                    </Typography>
                  </Box>
                  <Box className="orderDetailsWrapper">
                    <Box className="planDetails">
                      <Box
                        sx={{
                          display: "flex",
                          flexDirection: "column",
                          justifyContent: "center",
                        }}
                      >
                        <Chip label={subscription.name} className="planTitle" />
                      </Box>
                      <Typography variant="h4">{formatCurrency(price)}</Typography>
                      <Box mt={2} className="featureContainer">
                        {features.map((feature: IFeature) => (
                          <Box
                            key={feature.text}
                            display="flex"
                            alignItems="center"
                            justifyContent="left"
                            gap={1}
                          >
                            <CheckIcon color="success" className="featureIcon" />
                            <Typography variant="h6" textAlign="left" color={"#0F172A"}>
                              {feature.text}
                            </Typography>
                          </Box>
                        ))}
                      </Box>
                    </Box>

                    <Box>
                      <Box className="orderDetailsContainer">
                        <Box sx={{ marginBottom: "30px" }}>
                          <Typography variant="subtitle1" textAlign="center">
                            {configJSON.orderNumberText}: {order_number}
                          </Typography>
                        </Box>
                        <Box className="invoiceWrapper">
                          <Box className="invoiceLeft">
                            <Typography variant="body1">
                              {configJSON.billedToText}:{" "}
                              <span style={{ marginLeft: "26px" }}>{account.full_name}</span>
                            </Typography>
                            <Typography
                              variant="body1"
                              display="flex"
                              justifyContent="space-between"
                            >
                              {configJSON.orderDateText}: <span>{order_date}</span>
                            </Typography>
                            <Typography
                              variant="body1"
                              display="flex"
                              justifyContent="space-between"
                            >
                              {configJSON.validTillText}: <span>{valid_date}</span>
                            </Typography>
                            <Box
                              display="flex"
                              alignItems="center"
                              sx={{ fontSize: "14px", fontWeight: 400, lineHeight: "24px" }}
                            >
                              <Checkbox
                                data-test-id="autoRenewalCheckbox"
                                icon={<this.CustomUncheckedIcon />}
                                checkedIcon={<this.CustomCheckedIcon />}
                                checked={isAutoRenewal}
                                onChange={this.handleAutoRenewalChange}
                              />
                              {configJSON.autoRenewalText}
                            </Box>
                          </Box>
                          <Box className="invoiceRight">
                            <Typography variant="body1" sx={{ fontWeight: 600 }}>
                              {configJSON.orderSummaryText}
                            </Typography>
                            <Typography
                              variant="body1"
                              display="flex"
                              justifyContent="space-between"
                            >
                              {configJSON.subTotalText}:{" "}
                              <span>{formatCurrency(sub_total, false)}</span>
                            </Typography>
                            <Typography
                              variant="body1"
                              display="flex"
                              justifyContent="space-between"
                            >
                              {configJSON.gstText}: <span>{formatCurrency(gst, false)}</span>
                            </Typography>
                            <Typography
                              variant="body1"
                              display="flex"
                              justifyContent="space-between"
                              sx={{
                                fontWeight: 600,
                                padding: "14px 0px",
                                marginTop: "-11px",
                                borderTop: "1px solid #CBD5E1",
                                borderBottom: "1px solid #CBD5E1",
                              }}
                            >
                              {configJSON.totalAmountText}:{" "}
                              <span>{formatCurrency(total, false)}</span>
                            </Typography>
                          </Box>
                        </Box>
                      </Box>
                      <Box display="flex" justifyContent="center">
                        <CustomButton
                          fullWidth
                          disabled={isLoading}
                          data-test-id="pay-now"
                          customVariant="filled"
                          sx={{ mt: 2, minHeight: "56px", maxWidth: "360px" }}
                          onClick={this.handlePayNow}
                        >
                          {configJSON.payNowText}
                        </CustomButton>
                      </Box>
                    </Box>
                  </Box>
                </>
              );
            })()
          )}
        </Wrapper>
        <AppFooter navigation={this.props.navigation} />
        <CustomInfoDialog
          data-test-id="info-dialog"
          isOpen={isInfoDialog}
          infoType={infoType}
          title={infoMessage}
          description={infoDescription}
          handleClose={this.closeInfoDialog}
        />
      </ThemeProvider>
      // Customizable Area End
    );
  }
}

// Customizable Area Start
const Wrapper = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "center",
  flexDirection: "column",
  alignItems: "center",
  backgroundColor: "#EFF6FF",
  padding: `41.5px ${theme.spacing(4)} 50px`,

  "& .orderDetailsWrapper": {
    display: "flex",
    justifyContent: "center",
    padding: "50px 100px",
    gap: "29px",
    backgroundColor: "#fff",
    borderRadius: "12px",
    flexWrap: "wrap",
    '@media (max-width: 1300px)': {
      gap: "18px",
    },
    '@media (max-width: 600px)': {
      padding: "50px 10px",
    },
    '@media (max-width: 450px)': {
      padding: "50px 3px",
    },
  },

  "& .planDetails": {
    width: "340px",
    border: "1.5px solid #652784",
    borderRadius: "12px",
    padding: "40px 39px 50px 39px",
  },

  "& .planTitle": {
    padding: "5px 0px",
    maxWidth: "110px",
    color: "#FFFFFF",
    backgroundColor: "#652784",
    alignSelf: "center",
    fontSize: "20px",
    fontWeight: "600",
    lineHeight: "24.96px",
    borderRadius: "4px",
    marginBottom: "16px",
  },

  "& .featureContainer": {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },

  "& .featureIcon": {
    width: "12px",
    height: "12px",
  },

  "& .orderDetailsContainer": {
    border: "1.5px solid #652784",
    borderRadius: "12px",
    padding: "55px 58px",
    flexShrink: 1,
    '@media (max-width: 600px)': {
      padding: "48px 24px",
    },
  },

  "& .invoiceWrapper": {
    display: "flex",
    justifyContent: "center",
    flexShrink: 1,
    gap: "62px",
    flexWrap: "wrap",
  },

  "& .invoiceLeft": {
    width: "275px",
    display: "flex",
    justifyContent: "center",
    flexShrink: 1,
    flexDirection: "column",
    gap: "25px",
  },

  "& .invoiceRight": {
    width: "218px",
    display: "flex",
    justifyContent: "center",
    flexDirection: "column",
    gap: "25px",
  },

  "& .payNowBtn": {
    width: "360px",
    height: "56px",
    borderRadius: "30px",
    background: 'linear-gradient(90deg, #8077FF 0%, #652784 60%)',
    textTransform: "none",
    fontSize: "16px",
    fontWeight: 700,
    lineHeight: "24px",
  },
}));
// Customizable Area End